import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "requestguestordercancel-mutation"
    }}>{`requestGuestOrderCancel mutation`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`requestGuestOrderCancel`}</inlineCode>{` mutation allows a guest customer to request for cancelling an order, passing the order token and a cancellation reason.`}</p>
    <p>{`A guest customer can request for the cancellation of an order only if the following conditions are true:`}</p>
    <ul>
      <li parentName="ul">{`The guest customer has previously placed the order.`}</li>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`order_cancellation_enabled`}</inlineCode>{` configuration setting is `}<inlineCode parentName="li">{`true`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`The order has a status of `}<strong parentName="li">{`RECEIVED`}</strong>{`, `}<strong parentName="li">{`PENDING`}</strong>{`, or `}<strong parentName="li">{`PROCESSING`}</strong>{`.`}</li>
    </ul>
    <p>{`The mutation returns an error if the order cannot be cancelled.`}</p>
    <h2 {...{
      "id": "syntax"
    }}>{`Syntax`}</h2>
    <p><inlineCode parentName="p">{`mutation: { requestGuestOrderCancel(input: GuestOrderCancelInput!) {CancelOrderOutput}}`}</inlineCode></p>
    <h2 {...{
      "id": "reference"
    }}>{`Reference`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#mutation-requestGuestOrderCancel"
      }}><inlineCode parentName="a">{`requestGuestOrderCancel`}</inlineCode></a>{` reference provides detailed information about the types and fields defined in this mutation.`}</p>
    <h2 {...{
      "id": "example-usage"
    }}>{`Example usage`}</h2>
    <p>{`The following example cancels order with token `}<inlineCode parentName="p">{`0:3:LCFJT5Gbt1iGgeJJ2PWDA0yAQ+Z7yRZy3Ne7wjxG5QwHGsZgoXm1mACd5EHPZe6V5z9uR48EswbB`}</inlineCode>{` and includes the cancellation reason.`}</p>
    <p><strong parentName="p">{`Request:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`mutation {
    requestGuestOrderCancel(
        input: {
            reason: "Other",
            token: "0:3:LCFJT5Gbt1iGgeJJ2PWDA0yAQ+Z7yRZy3Ne7wjxG5QwHGsZgoXm1mACd5EHPZe6V5z9uR48EswbB"
        }
    ){
        error
        errorV2 {
            code
            message
        }
        order {
            status
        }
    }
}
`}</code></pre>
    <p><strong parentName="p">{`Response:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "data": {
    "requestGuestOrderCancel": {
      "error": null,
      "errorV2": null,
      "order": {
        "status": "Pending"
      }
    }
  }
}
`}</code></pre>
    <h2 {...{
      "id": "related-topics"
    }}>{`Related topics`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/commerce/webapi/src/pages/graphql/schema/store/queries/store-config.md#query-a-stores-order-cancellation-configuration"
        }}>{`order cancellation`}</a>{` configuration example on `}<inlineCode parentName="li">{`storeConfig`}</inlineCode>{` page.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      